import React from 'react';
import {
  Card,
  DetailsContainer,
  Title,
  Description,
  Category,
  ImageContainer,
  Image,
  AttributesWrapper
} from './StyledSearchResultCard';

import ContentTypeAttributes from '_utils/components/Corporate/ContentTypeAttributes';

import { convertSrcJss } from '_utils/media';
import { SearchResult } from '../SearchResults';
import NavItem from '../NavItem';

import { getContentType } from '_utils/helpers/contentType';

import { imageTransparentPlaceholderSrc } from '_utils/styles';

type SearchResultCardProps = {
  result: SearchResult;
  hostName: string;
};

const SearchResultCard: React.FC<SearchResultCardProps> = ({ result, hostName }) => {
  const { title, url, description, category, attributes = [], image = null } = result;

  const contentType = getContentType(result, 'contentType');

  return (
    <Card className={`type-${contentType}`}>
      <DetailsContainer>
        {category && <Category>{category}</Category>}
        <NavItem
          StyledLink={Title}
          link={{
            url: url,
            type: 'internal'
          }}
        >
          {title}
        </NavItem>
        <Description>{description}</Description>
        <ContentTypeAttributes
          attributes={attributes}
          contentType={contentType}
          Wrapper={AttributesWrapper}
        />
      </DetailsContainer>
      {image && (
        <ImageContainer>
          <Image
            className="lazyload"
            draggable={false}
            field={{
              value: {
                src: imageTransparentPlaceholderSrc,
                alt: image.alt,
                'data-src': convertSrcJss(image.src) + '?mw=200'
              }
            }}
          />
        </ImageContainer>
      )}
    </Card>
  );
};

export default SearchResultCard;
